const Page404 = () => (
  <div>
    <p className="text-red-500 font-semibold text-2xl">
      Page Not Found &#128549;
    </p>
  </div>
);

export default Page404;
